import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import ProDetailContainer from '../../components/pro/ProDetailContainer';
import { PRO_TAB_IDS } from './components/Tabs';

/**
 * /pro/:pronumber route. Owns URL parsing + activeTab-via-URL-hash; the
 * data-fetching, edit state, save flow, deadline modal, beforeunload
 * warning, and global-footer save button all live in ProDetailContainer
 * so the same content can be embedded in a drawer (ProDetailSlideOver).
 */
const ProPage: React.FC = () => {
  const { pronumber } = useParams<{ pronumber: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  // A Template pronumber starts with "T" (e.g. "T110") and must be passed
  // through as a string — "T110" and order "110" are different records, so it
  // must NOT be collapsed to a number. Normal pros keep numeric parsing.
  const isTemplate = !!pronumber && pronumber.trim().toUpperCase().startsWith('T');
  const proNum = pronumber && !isTemplate ? parseInt(pronumber, 10) : NaN;
  const hashId = location.hash.replace('#', '');
  const activeTab = PRO_TAB_IDS.has(hashId) ? hashId : 'order-info';
  const setActiveTab = (id: string) => navigate(`#${id}`, { replace: true });

  if (!isTemplate && Number.isNaN(proNum)) {
    return <div className="p-4 text-red-600">Invalid PRO number.</div>;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 min-h-0">
        <ProDetailContainer
          pronumber={isTemplate ? pronumber!.trim() : proNum}
          mode="page"
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
    </div>
  );
};

export default ProPage;
